const onChangeFunc = ({ target: { name, value } }, values, setValues) => {
  setValues({ ...values, [name]: value });
};

export { onChangeFunc };
